__turbopack_context__.v({
  "heroContainer": "Hero-module__Z8hQ_W__heroContainer",
  "heroContent": "Hero-module__Z8hQ_W__heroContent",
  "heroDescription": "Hero-module__Z8hQ_W__heroDescription",
  "heroImage": "Hero-module__Z8hQ_W__heroImage",
  "heroSlide": "Hero-module__Z8hQ_W__heroSlide",
  "heroTitle": "Hero-module__Z8hQ_W__heroTitle",
  "slideInOut": "Hero-module__Z8hQ_W__slideInOut",
});
